// src/components/ProtectedRoute.js

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const base64UrlDecode = (value) => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padding = normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4));
  const binary = atob(normalized + padding);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

const hasValidAdminToken = () => {
  if (typeof window === 'undefined') return false;
  const token = localStorage.getItem('adminToken');
  if (!token || typeof token !== 'string') return false;

  const parts = token.split('.');
  if (parts.length !== 3) return false;

  try {
    const payload = JSON.parse(base64UrlDecode(parts[1]));
    const exp = Number(payload?.exp || 0);
    if (!exp || exp <= Math.floor(Date.now() / 1000)) return false;
    return true;
  } catch {
    return false;
  }
};

const ProtectedRoute = () => {
  const isAuth = hasValidAdminToken();

  if (!isAuth) {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminEmail');
  }

  return isAuth ? <Outlet /> : <Navigate to="/admin/login" />;
};

export default ProtectedRoute;